import storage from '@epi-helpers/StorageHelper';

export const saveRequestedColumnsToStorage = columns => {
  columns.forEach(c => storage.set(`report${c.id}`, c.active));
};
